import template from './navbar.html';
import controller from './navbar.controller';

export const navbarComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};
